import { slicedToArray as _slicedToArray } from './_virtual/_rollupPluginBabelHelpers.esm.js';
import { Button } from '@costar-ui/components';
import { IconArrowThinLeft } from '@costar-ui/icons/csg/IconArrowThinLeft';
import { IconArrowThinRight } from '@costar-ui/icons/csg/IconArrowThinRight';
import React, { useMemo } from 'react';
import { useSpring, animated } from 'react-spring';

var exhibitStyleLeft = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  alignItems: 'center',
  boxSizing: 'border-box',
  userSelect: 'none',
  transform: 'translateX(0%)'
};
var exhibitStyleRight = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  alignItems: 'center',
  boxSizing: 'border-box',
  userSelect: 'none',
  transform: 'translateX(100%)'
};
var staticIconSize = '1.5em';
var leftButtonIcon = /*#__PURE__*/React.createElement(IconArrowThinLeft, {
  size: staticIconSize,
  color: "white",
  glowEffect: true
});
var rightButtonIcon = /*#__PURE__*/React.createElement(IconArrowThinRight, {
  size: staticIconSize,
  color: "white",
  glowEffect: true
});
var leftOnBack = {
  from: {
    transform: 'translateX(-100%)'
  },
  to: {
    transform: 'translateX(0%)'
  }
};
var rightOnBack = {
  from: {
    transform: 'translateX(0%)'
  },
  to: {
    transform: 'translateX(100%)'
  }
};
var leftOnForward = {
  from: {
    transform: 'translateX(0%)'
  },
  to: {
    transform: 'translateX(-100%)'
  }
};
var rightOnForward = {
  from: {
    transform: 'translateX(100%)'
  },
  to: {
    transform: 'translateX(0%)'
  }
};
function ContentCarousel(_ref) {
  var totalCount = _ref.totalCount,
    renderContentFor = _ref.renderContentFor,
    active = _ref.active,
    setActive = _ref.setActive,
    enableCaption = _ref.enableCaption,
    percentAspectRatio = _ref.percentAspectRatio;
  // we need to know which direction we're moving
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    forward = _React$useState2[0],
    setForward = _React$useState2[1];
  var prev = (totalCount + active - 1) % totalCount;
  var current = (totalCount + active) % totalCount;
  var next = (totalCount + active + 1) % totalCount;

  // initial left position
  var _useSpring = useSpring(function () {
      return {
        from: exhibitStyleLeft
      };
    }, []),
    _useSpring2 = _slicedToArray(_useSpring, 2),
    left = _useSpring2[0],
    leftApi = _useSpring2[1];

  // initial right position
  var _useSpring3 = useSpring(function () {
      return {
        from: exhibitStyleRight
      };
    }, []),
    _useSpring4 = _slicedToArray(_useSpring3, 2),
    right = _useSpring4[0],
    rightApi = _useSpring4[1];
  var onBack = React.useCallback(function () {
    setActive(prev);
    setForward(false);
    leftApi.start(leftOnBack);
    rightApi.start(rightOnBack);
  }, [setActive, prev, leftApi, rightApi]);
  var onForward = React.useCallback(function () {
    setActive(next);
    setForward(true);
    leftApi.start(leftOnForward);
    rightApi.start(rightOnForward);
  }, [setActive, next, leftApi, rightApi]);
  var _React$useMemo = React.useMemo(function () {
      return !totalCount ? [] : forward ? [renderContentFor(prev, 'prev'), renderContentFor(current, 'current')] : [renderContentFor(current, 'current'), renderContentFor(next, 'next')];
    }, [totalCount, forward, renderContentFor, prev, current, next]),
    _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
    leftContent = _React$useMemo2[0],
    rightContent = _React$useMemo2[1];
  var buttonClassname = useMemo(function () {
    var className = enableCaption ? 'absolute top-[calc(31.5%-29px)] flex h-[37%] w-[8%] cursor-pointer items-center justify-center border-0 bg-transparent/40 hover:bg-transparent/60' : 'absolute top-[31.5%] flex h-[37%] w-[8%] cursor-pointer items-center justify-center border-0 bg-transparent/40 hover:bg-transparent/60';
    return className;
  }, [enableCaption]);
  var aspectRatioStyle = useMemo(function () {
    var aspectRatioPercentage = percentAspectRatio ? "".concat(percentAspectRatio, "%") : '66.6666666667%';
    return {
      paddingBottom: aspectRatioPercentage
    };
  }, [percentAspectRatio]);
  return totalCount ? /*#__PURE__*/React.createElement("div", {
    className: "relative overflow-hidden",
    style: aspectRatioStyle
  }, /*#__PURE__*/React.createElement(animated.div, {
    style: left
  }, leftContent), /*#__PURE__*/React.createElement(animated.div, {
    style: right
  }, rightContent), /*#__PURE__*/React.createElement(Button, {
    className: buttonClassname + ' left-0',
    variant: "ghost-secondary",
    onPress: onBack
  }, leftButtonIcon), /*#__PURE__*/React.createElement(Button, {
    className: buttonClassname + ' right-0',
    variant: "ghost-secondary",
    onPress: onForward
  }, rightButtonIcon)) : null;
}

export { ContentCarousel };
//# sourceMappingURL=content-carousel.esm.js.map
